import type { DividerPolicy } from "@CommonTypes/backend/PspRules";
import type { DividerRuleError } from "@CommonUtils/pog/dividerPolicyValidation";
import type { RuleProposal, TellOUnit } from "@CommonUtils/pog/tellO/proposal";

/**
 * Tell O (DEV-3517): one sentence the chips and the local grammar did not
 * resolve, turned into a typed proposal. Nothing is stored; Apply goes through
 * the window's own rule and the by-store-shelf PUT.
 */
export const RoutePostMerchflows_merchflowId_DividerRulesInterpret =
  "/merchflows/:merchflowId/divider-rules/interpret";

export interface PayloadPostMerchflows_merchflowId_DividerRulesInterpret {
  /** At most 300 characters. */
  text: string;
  /** The window's current rule. */
  rule: DividerPolicy;
  unit: TellOUnit;
  /** For shelf counts and the base store. */
  basePogId: number;
  /** Only when the UI knows one (the shelf panel). */
  storeCode?: string;
}

export interface ResponsePostMerchflows_merchflowId_DividerRulesInterpret {
  proposal: RuleProposal;
  /** The weakest judgment the proposal rests on; 1 for the grammar. */
  confidence: number;
  /** Template-filled, e.g. "Read 'solids' as Solids (Level 2), 13 products."; "" when none. */
  rationale: string;
  /** The same template the client renders; for logs and tests. */
  sentence: string;
  /** "jev-1.13.0", or "grammar" when no model was asked. */
  model: string;
}

/** 400: the request's rule could not be read (`DIVIDER_RULE_INVALID`). */
export type ErrorPostMerchflows_merchflowId_DividerRulesInterpret = DividerRuleError;

/** 503: no key, or the model failed or took longer than 6 s. Chips and the grammar still work. */
export interface ErrorPostMerchflows_merchflowId_DividerRulesInterpretUnavailable {
  code: "O_UNAVAILABLE";
  message: string;
}
